import { API, axiosInstance } from "lib";

export const getEwayBillLrData = (data = {}) => {
  return axiosInstance
    .post(API.GET_EWAY_BILL + `ewaybillDetails`, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return err;
    });
};

export const getEwayBillList = (data = {}) => {
  return axiosInstance
    .post(API.GET_EWAY_BILL + `ewaylr_list`, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const extandEwayBill = (data = {}) => {
  return axiosInstance
    .post(API.GET_EWAY_BILL + `extendvalidity`, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const getEwayBillByDate = (data = {}) => {
  return axiosInstance
    .post(API.EWAY_BILL_BY_DATE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const getEwayBillListByDate = (data = {}) => {
  return axiosInstance
    .post(API.EWAY_BILL_LIST_BY_DATE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const getEwayBillTimeLine = (data = {}) => {
  return axiosInstance
    .post(API.EWAY_BILL_TIMELINE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const changeStatusEwayBillChecker = (data = {}) => {
  return axiosInstance
    .post(API.EWAY_BILL_STATUS_CHANGE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const calculateDistance = (data = {}) => {
  return axiosInstance
    .post(API.CALCULATE_DISTACE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const updateLrInformation = (data = {}) => {
  return axiosInstance
    .post(API.UPDATE_LR_INFORMATION, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return err;
    });
};

export const fetchAddEwayBillData = (data = {}) => {
  return axiosInstance
    .post(API.FETCH_ADD_EWAY_BILL, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return err;
    });
};